import { render, staticRenderFns } from "./DelayIcon.vue?vue&type=template&id=61236a34&"
import script from "./DelayIcon.vue?vue&type=script&lang=js&"
export * from "./DelayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports